import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirInkoTarangSettings() {
  return {
    loading: false,
    saving: false,
    form: {},

    init() {
      const raw = this.$el.dataset.config;
      try {
        this.form = JSON.parse(raw || '{}');
      } catch {
        this.form = {};
      }
      this.loading = false;
    },

    async save() {
      this.saving = true;
      try {
        const { data } = await axios.put('/api/v1/kasir/engagement/inko-tarang-settings', this.form);
        this.form = data.data;
        window.toast?.(data.message || 'Pengaturan disimpan.', 'success');
      } catch (e) {
        window.toast?.(e?.response?.data?.message || 'Gagal menyimpan.', 'error');
      } finally {
        this.saving = false;
      }
    },
  };
}

Alpine.data('kasirInkoTarangSettings', createKasirInkoTarangSettings);
